import { 
  ConversationSummary, 
  ConversationDetail, 
  ConversationStats, 
  AISummary 
} from './admin-types';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

class AdminAPIService {
  private token: string | null = null;

  setToken(token: string) {
    this.token = token;
  }

  clearToken() {
    this.token = null;
  }

  private getHeaders(): HeadersInit {
    return {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.token}`,
    };
  }

  async testAuth(): Promise<boolean> {
    try {
      const response = await fetch(`${API_BASE_URL}/api/admin/stats`, {
        headers: this.getHeaders(),
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }

  async getStats(): Promise<ConversationStats> {
    const response = await fetch(`${API_BASE_URL}/api/admin/stats`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch stats');
    }

    return response.json();
  }

  async getConversations(page: number = 1, limit: number = 20): Promise<{ 
    conversations: ConversationSummary[]; 
    pagination: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
      hasNext: boolean;
      hasPrev: boolean;
    }
  }> {
    const response = await fetch(
      `${API_BASE_URL}/api/admin/conversations?page=${page}&limit=${limit}`, 
      {
        headers: this.getHeaders(),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to fetch conversations');
    }

    return response.json();
  }

  async getConversationDetail(sessionId: string): Promise<ConversationDetail> {
    const response = await fetch(`${API_BASE_URL}/api/admin/conversations/${sessionId}`, {
      headers: this.getHeaders(),
    });

    if (!response.ok) {
      throw new Error('Failed to fetch conversation detail');
    }

    return response.json();
  }

  async summarizeConversation(sessionId: string, force: boolean = false): Promise<AISummary> {
    const response = await fetch(
      `${API_BASE_URL}/api/admin/conversations/${sessionId}/summarize`,
      {
        method: 'POST',
        headers: this.getHeaders(),
        body: JSON.stringify({ force }),
      }
    );

    if (!response.ok) {
      throw new Error('Failed to summarize conversation');
    }

    return response.json();
  }
}

export const adminAPI = new AdminAPIService();
